// Implements: F-UIX-018, F-USG-008
/**
 * `/backoffice/distribution` — "Distribución" (UIX.6): the organizations the person administers
 * (an editor, when the server allows it) and the ones where they lead a team (read-only).
 *
 * The page only composes: the targets, the reads, the writes and the rows live in the
 * `backoffice` module's `DistributionByOrganization`, which keys each organization's container
 * by its id (checklist 14). It is keyed here by the person as well, so another person signing in
 * on the same tab never inherits the previous one's choice or typed values.
 */

import type { ReactElement } from "react";

import { DistributionByOrganization } from "../../modules/backoffice/containers/DistributionContainer";
import { useSession } from "../../shared/api/session";
import { useTranslation } from "../../shared/i18n";
import { PageHeader } from "../../shared/ui/molecules/PageHeader";

export function DistributionPage(): ReactElement | null {
  const { t } = useTranslation();
  const { state } = useSession();
  // `RequireSession` renders this page only for a session; nothing to show otherwise.
  if (state.status !== "authenticated") return null;
  const { user, scopes } = state.view;

  return (
    <section>
      <PageHeader title={t("backoffice.distribution.title")} subtitle={t("backoffice.distribution.intro")} />
      <DistributionByOrganization key={user.id} scopes={scopes} />
    </section>
  );
}
